@if(!loading){
  @if(showMenu){
    <app-menu></app-menu>
  }
  <router-outlet>
    @if (isLocked) {
      <div class="app-lock">
        <div>
          <div class="loader"></div>
          <div class="message" [innerHTML]="lockMessage"></div>
        </div>
      </div>
    }
  </router-outlet>
  <app-message-viewer #messageViewer></app-message-viewer>
}
